import { ICreateFeriasUseCase } from "../../../presentation/useCases/create/create_ferias_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * CreateFeriasUseCase
 */

export class CreateFeriasUseCase implements ICreateFeriasUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async createFerias(
    idFuncionario: number,
    descricao: string,
    dataInicio: Date,
    dataTermino: Date,
  ): Promise<void> {
    await this.repository.createFerias(
      idFuncionario,
      descricao,
      dataInicio,
      dataTermino,
    );
  }
}